'use client'

import Cookies from 'js-cookie'
import { SWRConfig } from 'swr'
import { useEffect, useState } from 'react'
import type { ReactNode } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import { defaultLoginURL, isTKR } from '@/config'

const authTokenKey = 'yunionauth'

function isLoggedIn(): boolean {
  const authToken = Cookies.get(authTokenKey)
  return !!authToken
}

type SwrInitorProps = {
  children: ReactNode
}

const NewSwrInitor = ({
  children,
}: SwrInitorProps) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const consoleToken = searchParams.get('console_token')
  const consoleTokenFromLocalStorage = localStorage?.getItem('console_token')
  const [init, setInit] = useState(false)

  useEffect(() => {
    if (!isLoggedIn())
      globalThis.location.href = defaultLoginURL

    if (consoleToken) {
      localStorage?.setItem('console_token', consoleToken!)
      router.replace('/apps', { forceOptimisticNavigation: false } as any)
    }
    setInit(true)
  }, [])

  return init
    ? (
      <SWRConfig value={{
        shouldRetryOnError: false,
        revalidateOnFocus: false,
      }}>
        {children}
      </SWRConfig>
    )
    : null
}

const SwrInitor = ({ children }: SwrInitorProps) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const consoleToken = searchParams.get('console_token')
  const consoleTokenFromLocalStorage = localStorage?.getItem('console_token')
  const [init, setInit] = useState(false)

  useEffect(() => {
    // if (!(consoleToken || consoleTokenFromLocalStorage))
    //   router.replace('/signin')

    if (consoleToken) {
      localStorage?.setItem('console_token', consoleToken!)
      router.replace('/apps', { forceOptimisticNavigation: false })
    }
    setInit(true)
  }, [])

  return init
    ? (
      <SWRConfig
        value={{
          shouldRetryOnError: false,
        }}
      >
        {children}
      </SWRConfig>
    )
    : null
}

export default (isTKR ? SwrInitor : NewSwrInitor)
